import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { AShapeBg } from '../ui/DecorativeElements';

const { FiCheckCircle } = FiIcons;

const About = () => {
  return (
    <section id="about" className="py-24 relative overflow-hidden bg-alpha-grayLight">
      <AShapeBg className="text-alpha-navy w-96 h-96 -right-20 top-0" />
      <AShapeBg className="text-alpha-green w-64 h-64 -left-10 bottom-0" />

      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Left: Framed Imagery */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-square max-w-md mx-auto relative">
              {/* Geometric A-shaped mask wrapper */}
              <div className="w-full h-full mask-a-shape-soft bg-alpha-navy p-2 shadow-2xl">
                <img 
                  src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782380029/14_rht1mr.png" 
                  alt="Alpha Training Team" 
                  className="w-full h-full object-cover mask-a-shape-soft"
                />
              </div>
              {/* Floating accent image */}
              <div className="absolute -bottom-10 -right-10 w-48 h-48 border-8 border-white rounded-lg shadow-xl overflow-hidden hidden md:block">
                <img 
                  src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379407/2_bzxcey.png" 
                  alt="Domestic Worker Training" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">About Alpha Consultancy</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy mb-6 leading-tight">
              Empowering the Workforce with <br/>Industry-Leading Standards
            </h3>
            <p className="text-lg text-alpha-grayDark mb-6 leading-relaxed">
              At Alpha Training Consultancy, we believe that education and safety go hand-in-hand. As a premier government-accredited training provider, we specialize in delivering high-quality, practical training programs designed to elevate workforce competency across Singapore.
            </p>
            <p className="text-lg text-alpha-grayDark mb-8 leading-relaxed">
              Whether you are an employer ensuring compliance, a domestic worker settling in, or a construction professional seeking safety certification, our human-centric approach ensures you receive the best guidance and support.
            </p>

            <ul className="space-y-4">
              {[
                'Accredited by Major Government Bodies',
                'Comprehensive Safety & Settling-in Programs',
                'Experienced Industry Professionals as Trainers',
                'Tailored Corporate Consultation Services'
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <SafeIcon icon={FiCheckCircle} className="text-alpha-green text-xl mt-1 flex-shrink-0" />
                  <span className="text-alpha-dark font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;